import { createFileRoute } from '@tanstack/react-router'
import { ContractPage } from '../../../../../features/contracts/contract-page'
import { contractPageSearchSchema } from '../../../../../features/contracts/search'

export const Route = createFileRoute('/_app/service/contracts/$contractId/')({
  validateSearch: contractPageSearchSchema,
  component: ContractPage,
})
